// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__nHFaA","title":"AfterBackImages_title__1B-MG","images":"AfterBackImages_images__2jcmO"};